import { getUniversalBannerTimerParams, universalBannerTimerInit } from '../utils/timer'
import { checkWebp } from '../utils/check-webp'

export class UniversalNotice {
  constructor({ time, onClick }) {
    this._element = document.querySelector('.universal-notice')

    if (!this._element) {
      return
    }

    this._time = time
    this._onClick = onClick
    this._observer = null

    this._time && this.setTimer(this._time)
    checkWebp.then(support => this._element.classList.add(support ? 'universal-notice--webp' : 'universal-notice--no-webp'))
    this._element.addEventListener('click', this._noticeClickHandler)

    this._stickyElement = document.querySelector('.universal-notice-sticky')

    if (this._stickyElement) {
      this._stickyElement.addEventListener('click', this._noticeClickHandler)

      this._observer = new IntersectionObserver(this.observeBannerHandler)
      this._observer.observe(this._element)
    }
  }

  _noticeClickHandler = (evt) => {
    this._onClick && this._onClick(evt)
  }

  setTimer(time) {
    const xl = window.matchMedia(`(min-width: 1280px)`)
    const timer = this._element.querySelector('.js-universal-notice-timer')
    const endDate = new Date(time)
    const leftTime = endDate - new Date()

    if (leftTime > 0 && xl.matches) {
      universalBannerTimerInit(timer, getUniversalBannerTimerParams(leftTime))
      timer.classList.add('js-universal-notice-active')
    }
  }

  observeBannerHandler = ([entry]) => {
    this._stickyElement.classList.toggle('universal-notice-sticky--show', !entry.isIntersecting)
  }
}
